import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCleans } from "../features/clean/cleanSlice";
import { Card } from "../components/ui/card";
import { useLanguage } from "../context/LanguageContext";


const Clients = () => {
  const { t } = useLanguage();
  const dispatch = useDispatch();
  const { cleansList = [], loading } = useSelector((state) => state.cleans || {});

  useEffect(() => {
    dispatch(fetchCleans());
  }, [dispatch]);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        style={{
          padding: "8rem 1.5rem 4rem",
          background:
            "radial-gradient(at 50% 30%, hsla(108,100%,50%,0.2) 0px, transparent 50%)",
          textAlign: "center",
        }}
      >
        <div className="max-w-4xl mx-auto">
          <h1
            style={{
              fontWeight: 700,
              fontSize: "clamp(2.25rem, 5vw, 4rem)",
              lineHeight: 0.9,
              letterSpacing: "-0.02em",
              color: "rgb(0, 55, 32)",
              marginBottom: "1.5rem",
            }}
          >
            {t.nav.home === "Home" ? "Our Clients" : "Mitra Kami"}
          </h1>
          <p
            style={{
              fontSize: "clamp(1.125rem, 2.5vw, 1.25rem)",
              lineHeight: 1.5,
              color: "rgb(131, 146, 140)",
              maxWidth: "700px",
              margin: "0 auto",
            }}
          >
            {t.nav.home === "Home"
              ? "We proudly collaborate with organizations that care about sustainability."
              : "Kami bangga berkolaborasi dengan organisasi yang peduli terhadap keberlanjutan."}
          </p>
        </div>
      </section>

      {/* Grid Section */}
      <section style={{ padding: "4rem 1.5rem", background: "white" }}>
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <p className="text-center text-gray-500">Loading data...</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {cleansList.map((clean) => (
                <Card
                  key={clean.id}
                  className="product-card group transition-transform duration-300 hover:-translate-y-1"
                  style={{
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #f7faf9 100%)",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                    borderRadius: "16px",
                    padding: "2.5rem 2rem",
                    cursor: "pointer",
                    boxShadow:
                      "0 5px 15px rgba(0, 0, 0, 0.05), 0 0 10px rgba(0, 55, 32, 0.05)",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "280px",
                  }}
                >
                  <div
                    style={{
                      width: "110px",
                      height: "110px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginBottom: "1.5rem",
                      border: "3px solid rgba(0, 55, 32, 0.1)",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <img
                      src={clean.image}
                      alt={clean.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/100x100?text=No+Image";
                      }}
                    />
                  </div>

                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: "1.25rem",
                      lineHeight: 1.3,
                      marginBottom: "0.75rem",
                      color: "rgb(0, 55, 32)",
                    }}
                  >
                    {clean.title}
                  </h3>

                  <p
                    style={{
                      fontSize: "0.95rem",
                      color: "rgb(87, 99, 93)",
                      margin: 0,
                      lineHeight: 1.6,
                      maxWidth: "260px",
                    }}
                  >
                    {clean.description?.length > 90
                      ? clean.description.substring(0, 90) + "..."
                      : clean.description}
                  </p>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Clients;
